export const createStepData = (...stepIds) =>
  stepIds.reduce(
    (acc, stepId, stepIndex) => ({
      ...acc,
      [stepId]: {
        errors: [],
        id: stepId,
        index: stepIndex + 1,
        complete: false
      }
    }),
    {}
  )
